/**
 * Controller for the Search toolbar
 */
angular.module('impactx.search').controller('SearchToolBarCtrl', ['BackService', SearchToolBarCtrl]);

function SearchToolBarCtrl(BackService){

    this.back = BackService.back;
}